/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { CubeParamsInfo, InitiateMultipartUploadData, PathFileInfo } from './data-contracts'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class FileClient<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags File
   * @summary Скачивание файла из s3
   * @request GET:/seismicImport/api/v1/File/downloadFile
   * @secure
   */
  fileDownloadFile = (
    query: {
      /** Имя файла */
      filePath: string
    },
    params: RequestParams = {},
  ) =>
    this.http.request<File, any>({
      path: `/seismicImport/api/v1/File/downloadFile`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    }) /**
   * No description
   *
   * @tags File
   * @summary Метод проверки наличия файла в хранилище s3
   * @request GET:/seismicImport/api/v1/File/isExistFile
   * @secure
   */
  fileIsFileExists = (
    query: {
      /** Полный путь к файлу */
      filePath: string
    },
    params: RequestParams = {},
  ) =>
    this.http.request<boolean, any>({
      path: `/seismicImport/api/v1/File/isExistFile`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags File
   * @summary Удалить файл из s3
   * @request DELETE:/seismicImport/api/v1/File
   * @secure
   */
  fileDeleteFile = (
    query: {
      /** Полный путь к файлу */
      filePath: string
    },
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/seismicImport/api/v1/File`,
      method: 'DELETE',
      query: query,
      secure: true,
      ...params,
    }) /**
   * No description
   *
   * @tags File
   * @summary Загрузка файла в s3
   * @request POST:/seismicImport/api/v1/File/uploadFile
   * @secure
   */
  fileUploadFile = (
    data: {
      /**
       * Файл
       * @format binary
       */
      file: File
    },
    params: RequestParams = {},
  ) =>
    this.http.request<string, any>({
      path: `/seismicImport/api/v1/File/uploadFile`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags File
   * @summary Загрузка файла в s3 в папку
   * @request POST:/seismicImport/api/v1/File/uploadFileToFolder
   * @secure
   */
  fileUploadFileToFolder = (
    data: {
      /** @format binary */
      File: File
      Folder: string
    },
    params: RequestParams = {},
  ) =>
    this.http.request<string, any>({
      path: `/seismicImport/api/v1/File/uploadFileToFolder`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags File
   * @summary Загрузка коллекции файлов в s3
   * @request POST:/seismicImport/api/v1/File/uploadFileCollection
   * @secure
   */
  fileUploadFileCollection = (
    data: {
      Files: File[]
      Folder: string
    },
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/seismicImport/api/v1/File/uploadFileCollection`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    }) /**
 * No description
 * 
 * @tags File
 * @summary Метод инициализации загрузки файла частями
Часть не должна быть меньше 5mb
 * @request POST:/seismicImport/api/v1/File/initiateMultipartUpload
 * @secure
 */
  fileInitiateMultipartUpload = (data: InitiateMultipartUploadData, params: RequestParams = {}) =>
    this.http.request<string, any>({
      path: `/seismicImport/api/v1/File/initiateMultipartUpload`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
 * No description
 * 
 * @tags File
 * @summary Метод загрузки одной части файла для частичной загрузки
Ограничение: размер одной части должен быть больше 5mb(кроме последней) и количество частей должно быть меньше 10000
 * @request POST:/seismicImport/api/v1/File/uploadPart/{fileInfoId}
 * @secure
 */
  fileUploadPart = (
    fileInfoId: string,
    query: {
      /** Признак загрузки последней части файла */
      isLastPart: boolean
    },
    data: {
      /**
       * Загружаемая часть файла
       * @format binary
       */
      file: File
    },
    params: RequestParams = {},
  ) =>
    this.http.request<number, any>({
      path: `/seismicImport/api/v1/File/uploadPart/${fileInfoId}`,
      method: 'POST',
      query: query,
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags File
   * @summary Получить путь файла
   * @request GET:/seismicImport/api/v1/File/getFilePath/{fileId}
   * @secure
   */
  fileGetFilePath = (fileId: string, params: RequestParams = {}) =>
    this.http.request<PathFileInfo, any>({
      path: `/seismicImport/api/v1/File/getFilePath/${fileId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags File
   * @summary Получить пути файлов (используется для получения путей файлов профилей 2D съемки)
   * @request GET:/seismicImport/api/v1/File/GetFilePaths/{entityId}
   * @secure
   */
  fileGetFilePaths = (entityId: string, params: RequestParams = {}) =>
    this.http.request<PathFileInfo[], any>({
      path: `/seismicImport/api/v1/File/GetFilePaths/${entityId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags File
   * @summary Сохраненить настройки куба
   * @request POST:/seismicImport/api/v1/File/updateCubeConfig/{uploadId}
   * @secure
   */
  fileUpdateCubeConfig = (uploadId: string, data: CubeParamsInfo, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/seismicImport/api/v1/File/updateCubeConfig/${uploadId}`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    }) /**
   * No description
   *
   * @tags File
   * @summary Получить настройки куба
   * @request GET:/seismicImport/api/v1/File/getCubeConfig/{uploadId}
   * @secure
   */
  fileGetCubeConfig = (uploadId: string, params: RequestParams = {}) =>
    this.http.request<CubeParamsInfo, any>({
      path: `/seismicImport/api/v1/File/getCubeConfig/${uploadId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    })
}
